import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15 4.51924L18.5 1.71924L22 4.51924V21.9999H13V16H11V21.9999H2V4.51924L5.5 1.71924L9 4.51924V8.38183L12 6.88183L15 8.38183V4.51924ZM4 5.48049V19.9999H7V5.48049L5.5 4.28049L4 5.48049ZM17 5.48049V19.9999H20V5.48049L18.5 4.28049L17 5.48049ZM14 12H10V14H14V12Z"}}]};

const City4Filled = Vue.extend<IconProps>({
  name: 'City4FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'city-4-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default City4Filled;
